const trackedSubmissions = new Set();
const storageKey = 'jos-gtm-accepted-leads';
const forms = {
  consultation: { form_name: 'consultation_form', form_source: 'upper_form' },
  contact: { form_name: 'contact_form', form_source: 'lower_form' },
};
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Track provider-confirmed submissions, never form attempts or sensitive fields.
 * UUIDs are used ONLY for browser-local deduplication, not sent to analytics.
 * Optional analytics must never prevent a successful enquiry from completing.
 */
export function trackAcceptedLead({ receipt, httpStatus, submissionId, source }) {
  if (httpStatus !== 202 || receipt?.status !== 'accepted' ||
      receipt.id !== submissionId || !uuidPattern.test(submissionId) ||
      !Object.prototype.hasOwnProperty.call(forms, source)) return false;

  let stored = [];
  try {
    const value = JSON.parse(sessionStorage.getItem(storageKey));
    if (Array.isArray(value)) stored = value.filter(id => typeof id === 'string' && uuidPattern.test(id));
  } catch { /* In-memory deduplication still works if browser storage is blocked. */ }
  if (trackedSubmissions.has(submissionId) || stored.includes(submissionId)) return false;

  try {
    window.dataLayer = window.dataLayer || [];
    trackedSubmissions.add(submissionId);
    window.dataLayer.push({ event: 'generate_lead', ...forms[source] });
  } catch {
    trackedSubmissions.delete(submissionId);
    return false;
  }
  try {
    sessionStorage.setItem(storageKey, JSON.stringify([...new Set([...stored, ...trackedSubmissions])]));
  } catch { /* Do not interrupt lead success when storage is unavailable. */ }
  return true;
}